export const common = {
  videoPlayProblemTipTitle:'播放视频遇到问题?',
  walletBlanceTipTitle:'Messenger 隐私钱包提示',
  walletBlanceTipText1:'1. 请确认数字币在您的Mixin Messenger隐私钱包内。',
  walletBlanceTipText2:'哪里查看钱包：关闭机器人回到Messenger聊天页面，Messenger底部导航栏：「钱包」-「隐私钱包」。', 
  walletBlanceTipText3:'如资产在其他机器人例如ExinOne，Pando的交易账户，需要先在对应机器人平台划转到自己的Mixin隐私钱包。如在其他主链或平台，请提现充值到Mixin隐私钱包。',
  walletBlanceTipText4:'2. 请确认钱包内余额是否足够，另外注意USDT有多种版本，例如USDT(TRC20)、USDT(ERC20)等。确保与广告要求一致。',
  walletBlanceTipText5:'如版本不一致，建议筛选对应版本的广告，或者币币交易兑换为对应版本的USDT后再使用TIGA。',
  showHowToSellArticle:'查看如何出售数字币图文教程',
  stillhaveQuestion:'还有问题?',
  tradeDataTipsTitle:'指数说明',
  tradeDataTipsTitleSub:'广告发布者数据指数说明：',
  tradeDataTipsText1:'近30天内完成买卖订单总数量；',
  tradeDataTipsText2:'近30天内非接单广告类型订单中，15分钟内完成比例；',
  tradeDataTipsText3:'近30天内所有订单，完成比例；',
  tradeDataTipsText4:'近30天内所有订单，好评比例；',
  tradeDataTipsZhushi:'注：如30天内无订单，则使用旧数据比例。数据动态统计，可能有延迟，仅供参考。',
  plsAuthorizeMixin: '请授权Mixin账户登录',
  mixinWsLoading: '等待Mixin授权中...',
  cancelNeedClosePage: '请直接关闭本页面～',
  escrowConfirmTitle: '温馨提示',
  escrowConfirmText0:'交易订单的加密资产将托管到TIGA-safe，也是发起交易群聊的机器人:',
  robotMixinID: '7000104225',
  robotName: 'TIGA-safe',
  mixinIDTitle: 'MixinID:',
  nameTitle:  '名称:',
  escrowConfirmText1: '点击「支付托管」将打开Messenger支付页面，请确认转账信息无误后，输入PIN密码完成托管。',
  confirmPayEscrow: '支付托管',
  releaseConfirmTitle: '注意',
  releaseConfirmText0: '请务必在自己账户确认实际已到账且一致!',
  releaseConfirmText1: '如您已收到对方转账并同意释放资产到对方账户，请输入后面4位红色数字,并确认。',
  releaseCodeError: '请正确输入4位红色数字',
  choosePass3: '最多3项',
  coWarnTitle: '交易须知',
  coWarnText1: '交易前请熟悉平台规则并做好相关风控措施。',
  coWarnText2: '交易时请严格按照机器人提示操作。',
  coWarnText3: 'TIGA不对任何用户及行为做任何担保。',
  knownAgree: '本人承诺已知晓上述信息，理解并同意',
  adjustFeeTitle: '费率调整',
  adjustFeeText: '费率请知悉,详情「我的」-「交易费率」。',
  cancel: '取消',
  confirm: '确认',
  loading: '加载中...',
  noMore: '全部已加载',
  lang: '语言',
  buy: '购买',
  buyer: '买家',
  sell: '出售',
  seller: '卖家',
  edit: '编辑',
  remove: '移除',
  save: '保存',
  submit: '提交',
  back: '返回',
  pleaseInput: '请输入{input}',
  known: '我知道了',
  reapply: '重新申请',
  notice: '提示',
  copiedToClipboard: '已复制到剪贴板',
  follow: '关注 TIGA-safe',
  yes: '确认',
  no: '再想想',
  stopRemind: '下次不再提示',
  reauthorize: '重新授权',
  next: '下一步',
  start: '开始体验',
  sendMessage: '发送消息',
};
export const global = {
  settings: '设置',
  noticeListTitle: '公告列表',
  noticeDetailTitle: '公告详情',
  logoutInfo: '确定退出吗?',
  mine: {
    activity: '活动',
    service: '服务',
    about: '关于',
    green: '蓝盾认证',
  },
  tigaRatesInfo: {
    title: '交易费率',
    landunTextTitle:'蓝盾广告费率', 
    commonTextTitle:'普通广告费率', 
    markerText: '广告发布方(即挂单的一方):',
    takerText: '广告响应方(即拍单的一方):',
    markerTextOri: '广告发布方:',
    takerTextOri: '广告响应方:',
  },
  login: {
    agreeInfo: '继续登录即代表你已同意',
    agreementName: '用户协议',
  },
  faqs:[
    {
      q:'TIGA是什么',
      a: 'TIGA 是交易上链去中心化的C2C点对点交易平台。 <br/> 所有用户都可以自由发布广告和交易。<br/><span style="color:red;">TIGA不管理您的钱包</span>，是基于Mixin主链在Mixin Messenger上开发的机器人小程序。<br/> <span style="font-weight:bold;">请注意TIGA交易资产需为Mixin链上数字资产，即Messenger Mixin 隐私钱包内币种。</span>',
    },
    {
      q:'TIGA与其他平台区别',
      a:'C2C交易去中心化：TIGA没有中心化钱包，用户自己完全掌控自己的钱包和资产。<br/> 发布广告不用抵押资产给平台作为押金，交易实时链上托管，透明公开。任何人都可以自由挂单买卖，没有门槛。<br/> 端对端加密聊天。 <br/> 独立严格的平台风控措施，使用前建议阅读近期平台公告。',
    },
    {
      q:'什么是C2C点对点交易',
      a:'个人与个人直接买卖交易，用户自行确定托管币种，价格，付款方式等。<br/>平台在其中提供数字币托管，信息认证，规范订单流程等提升交易安全的服务。<br/>注意，平台不参与定价和交易，也不作任何担保。',
    },
    {
      q:'<span style="font-weight:bold;">如何使用</span>',
      a:'<a href="https://help.tigaex.com/zh/howtobuy.html">查看买币图文教程</a>----<a href="https://help.tigaex.com/zh/howtosell.html">查看卖币图文教程</a> <br/> <br/><a href="https://help.tigaex.com/zh/howtopost.html">查看发布广告图文教程</a>  <br/>1. 打开TIGA机器人首页，左上角按钮，点击【我要买】或者【我要卖】；<br/>2.  选择想要的广告，点击【购买】或【出售】；  <br/>3. 进入广告详情页， 输入交易额度并点击【发起交易】；<br/> 4.  如需重新进入群聊，订单详情页，点击【打开群聊】。<br/>5.  在群聊操作中，<span style="color:red;">请严格按照TIGA机器人提示的流程操作</span>。<br/>6.  首次交易建议小额先熟悉流程。 <br/>7. 如果您已经熟悉了买卖基本操作，可以尝试自己发布广告。自己把握交易流程,更自由，更安全。<br/><br/><br/><br/><br/>',
    },
    {
      q:'<span style="font-weight:bold; color:green;">如何确保交易流程安全</span>',
      a:'平台的核心是提供数字币托管，信息认证，规范订单流程等提升交易安全的服务。 ' +
   '<span style="font-weight:bold; color:red;">请务必按照机器人页面或消息提示操作。 </span><br/>' +
   '<span style="font-weight:bold;">购买数字币:</span><br/>' +
   '请在系统提示托管成功并提示您进行转账后（或在机器人订单详情页显示托管成功并出现「我已付款」按钮），仔细核对订单币种，数量，场外金额，及对方收款信息，确认无误后进行转账。' +
   '<br/><span style="color:red;">付款后及时点击「我已付款」，如遇到问题请立即联系 TIGA 人工客服。</span>' +
   '<br/><span style="font-weight:bold;">卖出数字币：</span>' +
   '请在对方付款后，务必到自己收款账户确认实际到账且确认信息无误后，点击「释放给对方」。 ' +
   '任何时候都不要依靠对方言语或截图来确定是否已到账。' +
   '<br/><span style="color:red;">如收到非本人实名的付款，点击「未收到款项」，并建议原路退回，并要求对方取消交易。</span>',
    },
    {
      q:'<span style="color:red; font-weight:bold;">特别提示</span>',
      a:'<span style="font-weight:bold;">对于一方或双方有异议的订单以及超过60分钟未完成的订单，平台有最终裁判权；</span><br/>TIGA作为信任去中心化交易的第三方，对于交易中可能出现的用户资产损失以及某些地区涉及司法的问题，<span style="color:red;">TIGA不作任何担保；</span>',
    },
    {
      q:'广告发布者禁止行为',
      a:'TIGA <span style="font-weight:bold;">不允许在TIGA平台之外通过卖出数字币收受人民币的行为；<br/>不允许私下交易行为尤其是诱导用户私下交易行为</span>。<br/> 一经发现将视影响程度对您的账户进行处罚，<br/>处罚方式有: 取消蓝盾认证，暂时或永久限制发布广告，暂时或永久限制账户等。<br/> 其他请查看<a href="http://help.tigaex.com/en/service-terms.html" target="_blank">用户条款</a>',
    },
    {
      q:'<span style="font-weight:bold;">如何预防诈骗，银行卡异常，冻卡等</span>',
      a:'请勿私下转账交易，遵守当地法律法规，遵守平台规则，以及仔细阅读平台有关风险控制及防诈骗公告或文章。',
    },     
    {
      q:'不认证是否可以交易',
      a:'可以交易，但取决于交易对方实际要求。而且一般用户都会要求认证，这不仅是行业通行规定，也可以有效降低交易风险。TIGA建议您及时完成实名和高级认证以便交易顺畅。',
    },
    {
      q:'是否必须绑定收款方式',
      a:'<span style="color:red;">不必须</span>。收款方式绑定只是将收款方式信息预先保留在TIGA系统中，以方便在交易群聊中自动发送给对方，并不代表TIGA对收款账户有任何担保或管理。<br/><span style="color:red;">实际您也可以在群聊中手动输入发送给对方。</span>',
    },
    {
      q:'<span style="color:#1b6fdc;">蓝盾是什么</span>',
      a:'蓝盾是平台对用户进一步认证，相比普通用户更有交易经验和风险意识。活动期间平台会给蓝盾用户更多的权限和费率优惠。请注意蓝盾只是基于用户数据记录的客观认证，并不表示TIGA对其有任何形式上的担保。<br/><span style="color:red;">蓝盾用户历史交易记录仅代表审核时间点前的交易记录，表明其具备良好的交易习惯和可能更高的信誉，不代表当前交易的安全性。</span>请在交易前仔细阅读 TIGA 平台近期有关风控和防诈骗公告。',
    },
    {
      q:'视频认证作用',
      a:'视频认证是进一步增强用户认证信息。 知悉风险及承诺资产合规的内容是为了进一步确保用户了解数字货币交易的风险、了解平台的合规要求，并承担相应的责任。 建议在大额交易时选择视频认证的用户。',
    },
    {
      q:'订单怎么取消',
      a:'订单应该先由双方协商取消。\n如对方未在线或暂不想交易，订单会在15分钟后自动取消；\n如交易过程中有分歧，请双方自行协商取消；\n如一方不响应或拒绝取消，请在订单超时60分钟后联系TIGA客服申诉取消。',
    },
    {
      q:'订单申诉',
      a:'提交申诉前请确认已通过Mixin Messenger 和电话联系过对方。\n如无法协商取消交易，订单超时60分钟后请联系客服并留言订单号、交易群聊截图、转账凭证等帮助仲裁。\n对于恶意申诉用户，平台将拉黑处理。\n对于不配合申诉或超次数无响应用户，平台也将拉黑处理。',
    },
    {
      q:'广告发布后怎么没显示',
      a:'请检查时区和时间段设置是否正确，并确定没有未支付手续费的订单。',
    },
    {
      q:'<span style="color:red;">为什么账户被限制及如何解除</span>',
      a:'TIGA系统会根据用户钱包流水和交易行为判定是否为高风险用户后自动拉黑，也有人工拉黑处理。请遵守当地法律法规。如需解除请联系TIGA工作人员或等待系统自动解除。',
    },
  ],
  faqsMore:'<span style="color:#1b6fdc;">更多</span>',
};
export const exchange = {
  name: '交易',
  noFindTitle: '未能找到您想要的广告',
  noFindSuggest:
    '很遗憾，没能找到您搜索的广告。您可以自己发布广告，然后等待其他人的回复。',
  allAds: '所有广告',
  postAnAds: '创建一个广告',
  filterMethod: '我想买/卖',
  methodFilterOptions: ['我要买/卖', '我要买', '我要卖'],
  filterCrypto: '加密货币',
  filterPayment: '转账方式',
  filterLocation: '所在地',
  filterLegalCurrency: '转账币种',
  allLegalCurrency: '所有币种',
  pickMethodTitle: '我想买/卖',
  pickTitle: '请选择{picker}',
  noLimit: '不限',
  anyPayment: '任意方式',
  anyWhere: '全部范围',
  tradeCount: '{count}次交易',
  praise: '好评',
  successRate: '成功',
  fast: '快速',
  optionalMode: '接单广告',
  tradeWith: '跟买/卖家交易',
  kyc: '已实名',
  blueTrust: '蓝盾认证',
  kycVideo: '视频认证',
  goKyc: '去认证',
  buy: '购买',
  sell: '出售',
  info: 'TIGA 是一个去中心化的点对点加密货币交易市场。交易教程：',
  notFound: '未找到符合条件的选项',
  filterPlaceholder: '请输入筛选条件',
  sortCondition: {
    created_at: '发布时间',
    updated_at: '修改时间',
    price_asc: '价格从低到高',
    price_desc: '价格从高到低',
    abs_price: '接近市价',
    order_count: '订单数',
    turnover: '总交易额',
    evaluation: '好评数',
    recommend: '推荐排序',
  },
};
export const post = {
  name: '发布',
  postAds: '创建广告',
  postAnAd: '创建一个广告',
  postDes:
    '请注意本页面发布广告仅支持Mixin链上资产,即Messenger隐私钱包资产, 发布广告前请熟悉平台规则并做好相应风险管控。TIGA不作任何担保。',
  myAds: '我发布的广告',
  buy: '购买',
  sell: '出售',
  delistAll: '下架所有广告',
  listAll: '恢复广告',
  delistAllAlert: '确认下架所有出售/购买广告吗？',
  listAllAlert: '仅恢复上次一键下架的广告',
};
export const createPost = {
  name: '创建广告',
  adType: '广告类型',
  optionalMode: '接单广告',
  unchecked: '关闭',
  checked: '开启',
  optionalModeBrief: '需要对方补充更多资料，以决定是否继续交易',
  onlyForSell: '该功能仅限【发布卖出广告】',
  attribute: '广告属性',
  public: '公开',
  private: '仅群组',
  crypto: '加密货币',
  payment: '支付/收款方式',
  fiatCurrency: '场外币种',
  customizePrice: '价格设置',
  tradeAmount: '交易限额',
  location: '地理位置',
  standardHours: '活跃时间',
  headline: '设置标题',
  termsOfTrade: '设置交易条款',
  trader: '交易对象',
  postAd: '发布广告',
  buy: '发布买入(数字币)广告',
  sell: '发布卖出(数字币)广告',
  default: '请选择',
  createSuccess: '创建成功',
  removeSuccess: '移除成功',
  saveSuccess: '保存成功',
  TakeOffSuccess: '已成功下架',
  putOnSuccess: '已成功上架',
  quit: '退出',
  quitContent: '您确定退出{action}广告吗？',
  removeContent: '您确认移除这个广告?',
  quitPosting: '创建',
  quitEditing: '编辑',
  setPriceAlert: '请先选取加密货币和场外币种',
  setAmountAlert: '请先选择场外币种',
  setPriceFirstAlert: '请先设置价格',
  takeOff: '下架',
  putOn: '上架',
  editInfo: '如果您需要编辑或者移除广告，请先下架',
  detail: '广告详情',
  defaultTrader: '默认所有人',
  selectedTrader: '特定条件用户',
  safeAlert: '抱歉，为了交易更安全，默认勾选的选项不支持取消。',
};
// Page Customize-XXX
export const customize = {
  fixedPrice: '固定价格',
  dynamicPrice: '动态价格',
  referencePrice: '参考价(不代表实际价值): ',
  referenceText:
    '您的当前价格（作为一个 seller）：1 {symbol} = {sellPrice} {unit} 。Buyer 的当前价格：1 {symbol} = {buyPrice} {unit}，包括 TIGA 费用。',
  isDeveloping: '动态价格功能还在开发中,敬请期待…',
  dynamicPriceText: ['选择利率和交易所作为您的价格基数', '输入一个利润百分比'],
  dynamicReference: '参考对象',
  dynamicAboveOrBelow: '高/低于',
  above: '高于',
  below: '低于',
  percentage: '百分比',
  minTradeAmount: '最小交易额',
  maxTradeAmount: '最大交易额',
  standardHoursTitle: '您是否想要设置你的 “活跃时间”',
  standardHoursSubtitle:
    '“活跃时间” 是指一天中进行交易的时间，如果您能快速响应交易方，您的交易将展示给更多的用户，在 “活跃时间” 之外的时间，若您无法及时响应，也不会受到任何惩罚。',
  timeZone: '选择所在时区',
  timeStart: '起床时间',
  timeEnd: '睡觉时间',
  difference: '价差',
  exinone: 'ExinOne 法币区',
  traderBrief: '设置后，可提高交易安全性，同时交易机会也会减少。',
  lowestPrice: '最低价',
  dynamicPriceNotice: '请注意此价格设置可能由于接口更新等原因偏离市场公允价格，请务必在实际交易前自行检查确认价格。',
};
// Page Mine
export const mine = {
  name: '我的',
  loginIn: '请登录',
  createdAt: '注册于 {date}',
  orders: '订单',
  userAgreement: '用户协议',
  privacyPolicy: '隐私条款',
  faq: '常见问题',
  customerService: '联系客服',
  about: '关于',
  exitSuccess: '退出成功！',
  what_is_kyc: '已通过实名',
  what_is_blue_trust: '在 TIGA 已通过蓝盾认证',
  firstLoginFailedTip: '首次登陆失败，请再次登录（将触发其他方式授权方式）',
};
// page apply
export const apply = {
  notice: '申请须知：仅限有发布广告需求的用户申请。',
  name: '申请蓝盾认证',
  personalInfo: '个人信息',
  trueName: '姓名',
  phoneNumber: '手机号',
  wait: '等待审核',
  waitInfo:
    '您的申请已提交，审核过程中会有工作人员联系您，请保持 Mixin 在线联系通畅',
  success: '申请成功',
  email: '邮箱',
  emergencyContact: '紧急联系人',
  emergencyContactNumber: '紧急联系人电话',
  emergencyContactRelationship: '紧急联系人关系',
  kycFirst: '您好，申请蓝盾需要先完成 KYC，请前往「我的，个人设置」完成 KYC 后再申请。',
  goKyc: '去认证',
  clickPlaceholder:'去认证',
  info: {
    title: '关于蓝盾认证审核标准',
    list: [
      '1. 注册使用 TIGA 超过 90 天及以上（蓝盾认证方的团队账户该条件可放宽）；',
      '2. 提交蓝盾认证申请时，需近半年内无 TIGA 平台用户反馈因其付款原因导致对方收款账户异常等记录；',
      '3. 账户及其管理人员未发送被警方刑拘、点名调查取证或警方冻结等被有关公权力机关采取调查或限制措施的过往史；',
      '4. 账户未出现严重违反或多次违反 TIGA 平台挂单交易相关条款；',
      '5. 通过服务部门、风控部门对该账户的综合服务水平及风控层面的考核评估；',
      '6. 审核流程中根据工作人员指引，认证方需要完成实名认证、高级认证；',
      '7. 如在其他 OTC 等平台从事场外挂单交易累计成功交易超过 100 笔及以上的，可放宽其他标准；（申请后需要提交相关资料佐证）',
      '8. 满足以上条件，按照报名时间先后，分批次审核添加。',
    ],
  },
  info1: {
    title: '申请蓝盾认证优势：',
    list: [
      '1、活动期间手续费 0.1%，非蓝盾认证固定 0.25%；',
      '2、挂单支持选择交易对象，交易安全性提高。',
    ],
  },
  QAs: [
    {
      question: '请问你是计划使用 TIGA 来如何交易呢？',
      options: ['主要拍单交易', '主要挂单交易', '拍单挂单都有'],
    },
    {
      question: '请问你有使用过其他数字货币交易平台吗？',
      options: [
        '没有，只用过 TIGA 法币交易',
        '有用过 Mixin 生态内的其他法币交易比如 ExinLocal、ZOTC',
        '有用过 Mixin 生态外的其他交易所如火币、BigONE、OKEx 等交易所',
      ],
    },
    {
      question: '有使用过其他数字货币交易平台法币交易数字货币吗？',
      options: [
        '只买过，没卖过',
        '只卖过，没买过',
        '买卖都有',
        '很久之前用过，最近一年内没有用过了',
      ],
    },
    {
      question: '请问你挂单的需求主要是？',
      options: ['低价收 U 定投', '搬砖赚钱', '其他'],
    },
  ],
  tips: {
    tips: '温馨提示',
    title:'您需要完成以下操作，才能继续申请蓝盾认证：',
    kycFirst:'您好，请先完成实名认证。',
    advKycFirst:'您好，请先完成高级认证。',
    noSixtyDays:'您好，您的注册TIGA时间不足 60 天，不符合申请条件。',
    failed:'暂不符合申请条件。',
    ndlich:'拍单无需申请认证。',
    no:'您需要完成以下操作，才能继续申请蓝盾认证：',
    notHasOrder:'您好，非蓝盾用户也可以使用 TIGA 交易，直接下单即可，无需申请蓝盾认证。',
    tipsLsit: [
      '拍单无需申请认证。',
      '暂不符合申请条件。',
      '已提交申请，预计会在2个工作日内审核完成，可联系 Alim 查询进度。',
      '您好，请先完成实名认证。',
      '您好，请先完成高级认证。',
      '您好，您的注册TIGA时间不足 90 天，不符合申请条件。',
      '您好，请先注册账号并完成实名认证。',
      '您好，非蓝盾用户也可以使用 TIGA 交易，直接下单即可，无需申请蓝盾认证。',
      // '您好，请体验 TIGA 的交易流程，直接使用交易功能无需申请认证。',
      '您需要完成以下操作，才能继续申请蓝盾认证：',
      '请简单填写您的需求',
    ],
  },
  noMatch: '未匹配到结果',
  search: '搜索',
  exinone:'ExinOne',
};

// Page Orders
export const orders = {
  name: '订单记录',
  noRecords: '没有订单记录',
  buy: '购买 {symbol}',
  sell: '出售 {symbol}',
  amount: '数量',
  price: '价格',
  total: '总价',
  all: '全部订单',
  done: '已完成',
  pending: '未完成',
  cancel: '已取消',
  startingTime: '开始时间',
  endTime: '结束时间',
  startingTimeTips: '选择开始时间',
  endTimeTips: '选择结束时间',
};
export const newSettings = {
  todamoonTitle: '相关说明',
  todamoonDetails: [
    {
      title:
        '真·去中心化',
      content:
        'TIGA基于Mixin多签功能，整个交易过程中数字资产在多签地址上，无需信任，真正去中心化；',
    },
    {
      title: '功能完备',
      content:
        'KYC、高级KYC、社群助手、邀请返佣、统计、名单管理等功能齐备；',
    },
    {
      title:
        '<span class="strong">蓝盾用户他所即我所</span>',
      content: '币安、火币、ExinLocal等蓝盾用户只需基本KYC认证后，可直接申请蓝盾，<span class="strong">活动限时请及时申请</span>；',
    },
    {
      title: '<span class="strong">来TIGA，多一个选择</span>',
      content: '不说了，赶紧上车吧~',
    },
  ],
  applyGreen:{
    title: '蓝盾认证',
    warningInfoTitle:'重要说明：',
    warningInfo:' 1.年龄45岁以下，熟悉和理解平台规则及特点，能自行解决订单纠纷以外的任何流程问题。能积极友好地与交易对方或平台沟通，并配合解决各类问题。 \n 2.注册TIGA满360天，并通过高级认证 和 视频认证; \n 3.必须有买卖完成的订单记录，且买入数字币10单以上，单笔金额在10000cny以上，且付款资金在对方账户沉淀至少15天以上且无异常反馈记录； \n 4. 无私下交易，以及诱导私下交易记录; \n 5.如果您已经满足上述情况，请留言客服，实际通过与否待进一步审核。 \n 特别注意：以上为基本条件，实际认证规则会根据风控有动态调整趋于更严格，以联系审核人员为准。 请如未通过请至少在30天后再发起申请。蓝盾认证与否不影响发布广告和交易功能。',
    waitInfo:'请添加审核人员为好友，并说明需求：蓝盾认证，谢谢。',
    contactServiceMan:'联系审核',
  },
  kyc:{
    title: '实名认证',
    resultTitle: '实名认证状态',
    trueNameErr: '姓名不能为空',
    idcardNumberErr: '身份证号码不能为空',
    idcardFrontErr: '身份证正面不能为空',
    idcardBackErr: '身份证背面不能为空',
    idcardWithErr: '手持照片不能为空',
    uploadTips:'温馨提示：请保持照片文字资料一致，本人手持证件和有‘TIGA’字样的纸张(任意白纸手写或打印"tiga"均可)，拍照时保持人脸和证件清晰，勿遮挡脸部及证件。身体头部肩部需出镜，证件靠近身体「同时」尽量靠镜头。如多次提交【请求超时】请压缩照片或切换更快的网络后再试。（照片通过发送到微信等聊天软件后再保存即可有效压缩）',
  },
  kycAdv:{
    title: '高级认证',
    photosInfo: '资料照片', 
    photosLimit: '最多上传6张照片',
    photosEmptyErr: '照片不能为空', 
    uploadTips:'温馨提示：请提供【身份证除外】「同时包含」：本人姓名，证件号码，地址信息的【私人证件或单据】1张或多张，如驾照，户口页，房产证，购房合同，契税，水电气缴纳记录等。建议上传2张以上，以更快通过。根据风控不同可能对不同用户的资料要求不同，请留意审核结果。如多次提交【请求超时】请压缩照片或切换更快的网络后再试。（照片通过发送到微信等聊天软件后再保存即可有效压缩）',  
  },
  kycVideo:{
    tempForChineseOnly: '暂时只接受中国大陆区域用户使用',
    notKeepInfo:'声明：您的视频信息TIGA将严格保密。',
    title: '视频认证',
    katoonTitle: '视频认证拍摄动画说明',
    nickname: '昵称',
    videoInfo: '视频', 
    videoLimit: '建议视频大小勿超过10M',
    videoEmptyErr: '视频不能为空',
    uploadTips:'本人姓名***， 身份证号****，已知晓TIGA平台规则，已知晓TIGA不作任何担保，已知晓交易数字币风险，本人所有资产或款项均合法所得，所有交易行为均为本人自愿且亲自处理，风险全部由本人承担。(TIGA按英文字母tiga依次读，也可读“迪迦”或“泰格”)',
    uploadTips1:'请手持身份证和TIGA纸张(任意白纸上手写TIGA即可)，口述上述蓝色字体内容（不包含括号内，不要增加或减少字句）, 期间拍摄证件正反面。',
    uploadSkill: '建议上传视频前将视频压缩，例如通过微信等聊天软件再保存后可有效压缩。如还有问题请直接联系客服解决。 TIGA也可以读作“迪迦”“提呷”“泰格”等类似读音，但一般必须与TIGA纸张同时出镜，审核以表意明确为准。',  
    iphoneUploadTips: '部份手机系统例如iphone IOS,如上传压缩后的视频时还是提醒文件过大（ios系统机制自动转换了）。请在上传时不要选择「照片图库」，而是选择「选取文件」(位置「浏览」-「我的iphone」)。进入本页面之前需将压缩后的mp4视频进行如下操作：手机照片中选择压缩后的视频「共享」-「导出未修改的原片」-「存储」（存储位置：「浏览」-「我的iphone」）',
    uploadTipsSpecial: '特别注意：请勿遮挡面部，保持画面和语音清晰。期间翻转拍摄证件正反面时，靠近镜头，确保证件聚焦清晰，注意人和证件一直同时在镜头内。',
    scrollForTips: '向下滑动查看更多拍摄提示',
  },
  apply:{
    wait: '审核中',
    waitInfo:'您的信息正在审核当中，一般一个工作日内审核完毕。请耐心等待，谢谢',
    adopted:'已通过',
    adoptedInfo:'恭喜！您的认证已通过！',
    fail:'审核未通过',
    failInfo:'原因：',
    forbidden: '禁止提交',
    forbiddenInfo:'原因：',
  },
  notKeepInfo:'声明：您的照片信息仅用作TIGA平台审核使用。',
  personalInfo: '个人信息',
  trueName: '姓名', 
  nickname: '用户昵称',
  idcardNumber: '身份证号码', 
  idcardFront: '身份证正面', 
  idcardBack: '身份证反面', 
  idcardWith: '手持身份证及有“TIGA”字样的纸张', 
  upload: '上传', 
  reUpload: '重新上传', 
  uploadInfo:
  '温馨提示：请保持照片文字资料一致，手持证件和写有‘TIGA’字样的纸张，保持证件清晰可见。',
  tips:{
    trueNamePlaceholder:'请输入真实姓名',
    idNumberPlaceholder:'请输入身份证号码',
  },
  incorrect: '请输入正确的{name}',
};
export const payInfo = {
  name: '个人设置',
  settings: [
    {
      title: '法币首选',
      placeholder: '首页默认展示该法币',
    },
    {
      title: '收款方式',
      content: '已添加',
      placeholder: '未添加收款方式，这里添加',
    },
    {
      title: '手机绑定',
      placeholder: '去绑定',
    },
    {
      title: '邀请码绑定',
      placeholder: '去绑定',
    },
    {
      title: '实名认证',
      placeholder: '去认证',
    },
    {
      title: '高级认证',
      placeholder: '去认证',
    },
    {
      title: '视频认证',
      placeholder: '去认证',
      content: '去认证',
    },
  ],
  goKycAlert: '您好，即将去实名认证，完成之后再返回到 TIGA 交易。',
  goKyc: '去认证',
  passed: '已通过',
  settingInfo:
    '添加收款方式旨在让交易更便捷，TIGA 非常注重用户隐私，收款方式不是强制要求添加。',
  noKycAlert: '请先进行实名认证。',
  noKycAdvAlert: '请先进行高级认证。',
  syncAlert: '同步时会覆盖当前数据，是否确认同步？',
  cancelSync: '取消同步',
  confirmSync: '确认同步',
  syncing: '同步中，请稍后...',
  synced: '同步成功',
  add: '添加',
  addPayment: '添加支付方式',
  trueName: '姓名',
  edit: '编辑',
  bankAccount: '银行账号/卡号',
  bankName: '银行名称',
  openingBank: '开户支行（选填）',
  alipayAccount: '支付宝账号',
  wechatAccount: '微信账号',
  removeSuccess: '移除成功',
  personalInfo: '个人信息',
  qr: '收款二维码（选填）',
  upload: '上传',
  uploadInfo:
    '温馨提示：当您出售或购买加密货币时，您选择的收款方式将向对方展示，请确认信息填写准确无误。',
  deleteAlert: '确认移除当前支付方式？',
  recommand: '推荐收款方式',
  next: '下一步',
  incorrect: '请输入正确的{name}',
  authorizeAlert: '您好，绑定手机号需要授权手机号权限，请不要取消勾选。',
  select: '请选择一种收款方式',
  send: '发送',
  sendSuccess: '发送成功，请点击右上角「X」关闭当前页面。',
  default: '设置为默认收款方式',
  setDefault: '确认将 {payMethod} 设置成默认的收款方式？',
  cancelDefault: '确认取消默认的收款方式？',
  switchOpened: '收款方式已开启',
  switchClosed: '收款方式已关闭',
  bindRuleErrorInfo: '抱歉，已有交易的账户，不再支持绑定。',
};

export const takeOrder = {
  amountErrorTip: '您当前Messenger 隐私钱包 {symbol} 余额为 0 或无法获取，请确认钱包资产是否与广告一致或升级Messenger最新版本后再试。 如仍存在问题建议卸载重装（注意备份聊天记录）。',
  notPrimaryWebAmountTip: '您当前使用的不是TIGA机器人主网站页面，无法获取钱包资产余额，请自行确认该资产余额足够后，直接发起交易即可。（USDT请区分广告版本）',
  amountZeroTip: '请在Mixin 隐私钱包确认资产情况。',
  titleSell: '你是买家，通过 {name} 转账至卖家的帐号',
  titleBuy: '你是卖家，通过 {name} 收款',
  titleMultiSell: '你是买家，通过约定的方式转账至卖家的账号',
  titleMultiBuy: '你是卖家，通过约定的方式收款',
  priceInfo: '{name}设置了这个价格,当前价格波动较大请仔细确认<br/>只有在您同意的时候才能继续交易',
  tradeLimit: '交易限额',
  takeOrder: '发起交易',
  safetyInfo:
    '发起交易后订单将在Mixin Messenger加密群聊继续完成。交易群聊开始后请及时响应，以避免造成自己或对方可能的损失。',
  priceNotInRange: '金额不在对方要求的范围内',
  lastSeen: '最近一次登录 {duration}',
  successMsg: '请在 Mixin Messenger 群聊中继续交易，点击「确认」打开群聊。',
  noSupported: '您当前的 Mixin 版本可能不支持多签功能，建议升级到最新版本。',
  notEnoughAmount: '您当前的 Mixin 隐私钱包内该资产余额不足，请检查资产版本是否一致。详细说明请查看输入框下方的提示信息。',
  limitedTimeActivity: '限时活动：和蓝盾认证用户交易限时免手续费，交易更丝滑。',
  share: '分享',
  contact: '联系对方',
  shareMsg: '点击右上角 3 个点，分享给他人快速下单',
  sellTo: '出售{coin}给{name}',
  buyFrom: '向{name}买入{coin}',
  balance: 'Mixin 隐私钱包余额: ',
  needBalance: '为成功交易请确保 Mixin 钱包余额高于：',
  lessThanMin: '小于单笔最小金额',
  moreThanMax: '超出单笔最大金额',
  forbiddenRemark:
    '转账或者添加好友时，<b class="important">请不要备注任何信息</b>，否则您的账号可能被冻结，对方也可能不退款不放币。',
  optionalModeDetail:
    '接单广告相比普通广告，交易更安全。您下单后，对方需要您补充更多资料（比如查流水），以决定是否继续交易。对方托管后您可取消，不计入当日取消次数。',
};

export const payments = {
  BinanceTransfer: '币安',
  OKXTransfer: '欧易',
  BigONETransfer: '币格',
  GateioTransfer: 'Gateio',
  CryptoTransfer: '钱包地址',
  alipay: '支付宝',
  wechatpay: '微信',
  unionpay: '银联卡',
  YandexMoney: 'Yandex.Money',
  'Western Union': '西联汇款',
  PayPal: 'PayPal',
  'Mercado Pago': 'Mercado Pago',
  Paytm: 'Paytm',
  'International wire': '国际汇款',
  'Gift card': '礼品卡',
  'Cardless cash': 'ATM现金取现码',
  Efecty: 'Efecty',
  QIWI: 'QIWI',
  Pingit: 'Pingit',
  'Bank transfer': '银行转账',
  Venmo: 'Venmo',
  Swish: 'Swish',
  'SEPA transfer': 'SEPA transfer',
  MoneyGram: 'MoneyGram',
  Other: 'Other',
  'Cash deposit': 'Alfa cash-in',
  AdvCash: 'AdvCash',
  WebMoney: 'WebMoney',
  UPI: 'UPI',
  'WeChat Pay': '微信支付',
  TransferWise: 'TransferWise',
  'Interac e-Transfer': 'Interac e-Transfer',
  IMPS: 'IMPS',
  'M-PESA': 'M-PESA',
  Skrill: 'Skrill',
  'Cash (in person)': '现金交易(当面交易)',
  Alipay: '支付宝',
  PayNow: 'PayNow',
  PAYEER: 'PAYEER',
  'Alfa cash-in': 'Alfa cash-in',
  Velo: 'Velo',
  'Google Pay': 'Google Pay',
  default: '-',
  // 'Bank transfer': '银行转账',
  // 'Cash deposit': '现金存现',
};

export const result = {
  cancelContent:
    '您好，请谨慎取消交易，当日取消超过 2 次无法继续下单，还有可能会被系统限制，请规范使用。',
  notReceivedContent: '您确认没有收到对方的转账?',
  cancelTransaction: '取消交易',
  transferAlert:
    '您好，您确认已经向对方付款了吗？如果您未付款，多次恶意点击，可能会被限制使用 TIGA。',
  close: '关闭提示',
};

export const error = {
  occur: '发生错误：',
  occurs: '发生错误',
  para: '参数错误',
  unknown: '未知错误',
  jwtInvalid: '登录凭证失效，请重新登录',
  jwtUpdated: '已经更新凭证，请重试',
  jwtExpired: '登录凭证过期，请重新登录',
  jwtUpdating: '正在重试更新登陆凭证',
  reqTimeout: '请求超时，请重试',
  networkError: '网络错误，请检查网络连接',
  forbidden: '禁止访问',
  tooManyReq: '请求过于频繁',
  serverError: '服务器错误，请稍后再试',
  notTradeWithSelf: '广告发起人不能进行交易',
  notSend: '该笔托管还未支付',
  notSign: '没有可以签名的数据',
  notUnsign: '没有可以取消签名的数据',
  notWithdraw: '没有可以提出的资产',
  insufficientBalance: '资产余额不足',
  incorretPrice: '法币价格计算有误',
  withoutLimit: '成交价格必须在交易限额之间',
  tokenMiss: 'Token 丢失',
  tradeOver: '该交易已经结束',
  inSigning: '该交易已在签名阶段',
  notRepeat: '请勿重复操作',
  notEscrowed: '该交易还没托管',
  notRelease: '签名还没集齐，无法释放资产',
  permissionDenied: '您没有权限操作',
  needCancelSignature: '该交易已在签名阶段，请先取消签名',
  needCancelEscrow: '该交易已托管，请先取消托管',
  notCancel: '该交易已结束，无法取消',
  abnormalStatus: '交易状态异常',
  isCanceled: '该交易已经取消了',
  delistBeforeEdit: '广告上架中，不能进行编辑操作',
  delistBeforeDelete: '广告上架中，不能进行删除操作',
  isDelisted: '该广告已经下架，不能进行交易',
  sellerIsNotEnough: '对方的币种数量不足以进行交易',
  buyerIsNotEnough: '您的币种数量不足以进行交易',
  refundFailed: '手续费退还转账失败',
  loginDenied: '拒绝登录',
  notCheckCounterpartyAssets: '无法检查对方资产是否充足',
  uncompeletedTrade: '请先完成上一笔交易',
  outOfRateRange: '为了维护健康的市场环境，动态价格的比率建议设置在 5% 上下。',
  invalidEmail: '请输入正确格式的邮箱',
  unsupportedCrypto: '抱歉，ExinOne 法币区暂时不支持该币种',
  unsupportedExinOne: '抱歉，ExinOne 法币区暂时只支持人民币价格',
  onlyKyc:
    '卖家设置仅支持实名认证用户下单，请先去完成实名认证',
  onlyOldUser: '抱歉，对方设置仅支持注册时间 90 天及以上的用户交易',
  onlyHasTrade: '抱歉，对方设置仅支持交易 5 笔及以上的用户交易',
  onlyHighQuality: '抱歉，对方设置仅支持优质用户交易。',
  notSatisfiable: '抱歉，您暂不符合对方的交易对象要求',
  outOfAdLimit: '同个类型的广告不能超过三个',
  advVerify:
    '抱歉，您触发了高级认证，无法继续操作，请完成高级认证',
  joinChatFailed: '抱歉，拉群失败，请将 TIGA 机器人添加为联系人',
  postKyc: '抱歉，发布广告要求实名，请先去完成实名认证',
  onlyWhiteList: '您好，对方设置了仅白名单可交易，请选择其他用户。',
  reauthorized: 'Mixin 授权失效，需要您重新授权',
  optionalMode:
    '为了确保不为各种违法行为提供服务，请开启「接单广告」，严格审查对方的资金明细流水，确保交易安全。',
};

export const orderDetail = {
  name: '订单详情',
  orderNumber: '订单号',
  buyer: '买方',
  seller: '卖方',
  cryptoWallet: '收币钱包',
  paymentMethods: '付款方式',
  amount: '数量',
  price: '价格',
  total: '总价',
  yourRating: '您的评价',
  opponentRating: '对方的评价',
  orderProgress: '订单进度',
  assistance: '如需帮助，请在 TIGA 机器人留言。',
  escrow: '托管中',
  paid: '待付款',
  draw: '待释放',
  done: '已完成',
  cancel: '已取消',
  joinChat: '打开群聊',
  sellerPhone: '卖家联系方式',
  buyerPhone: '买家联系方式',
};

export const evaluation = {
  name: '评价',
  hello: '您好，您已交易完成，请给对方评价',
  good: '好评',
  bad: '差评',
  mid: '一般',
  assistance: '如需帮助，请在 TIGA 机器人留言。',
  reason: '您好，您选择了差评，请勾选原因',
  timely: '回复不及时',
  slow: '付款慢',
  process: '流程不熟悉',
  other: '其他',
  limit: 'Hi, TIGA 20字符限制',
  submit: '提交',
  haveEvaluated: '您已经评价过了',
  evaluateSuccess: '评价成功',
  tips: '请选择差评理由',
  otherReason: '请输入差评理由',
};

export const logStatus = {
  create_group: '交易创建中',
  start: '托管中',
  escrow: '已托管',
  escrow_need_check: '已托管待确认',
  deal_continue: '确认继续交易',
  many_payments: '等待选择收款方式',
  paid: '已付款',
  transfer_asset: '待释放',
  pay_confirm: '已确认付款',
  sign_asset: '已确认转账',
  draw_asset: '已释放',
  transfer_fee: '请求手续费',
  sign_fee: '已付手续费',
  draw_fee: '已完成',
  cancel: '已取消',
  cancel_paid: '取消请求',
  cancel_escrow: '释放中',
  not_received: '款项未收到',
  unlock: '撤销转账',
  refund_fee: '返还手续费',
  auto_cancel: '订单自动取消',
};

export const notice = {
  title: '智能交易',
  fiatCurrency: '货币',
  minPercentage: '价格最小值',
  maxPercentage: '价格最大值',
  above: '高于',
  below: '低于',
  frequency: '通知频率',
  add: '添加',
  edit: '编辑',
  delete: '删除',
  smartTradingEdit: '智能交易编辑',
  type: '订单类型',
  crypto: '币种',
  alertCount: '通知次数',
  alertGap: '通知间隔',
  sace: '保存',
  buy: '我想买',
  sell: '我想卖',
  default: '请选择',
  setPriceAlert: '请先选取加密货币和场外币种',
  times: '次',
  saveSuccess: '修改成功',
  createSuccess: '创建成功',
  removeSuccess: '删除成功',
  changeSuccess: '切换成功',
  tips: '修改之后只能在新发布的广告中生效',
  notZero: '您好，动态价格百分比不允许设置为 0',
  priceError: '价格最小值不能大于价格最大值',
  smartTrade:
    '智能交易是指如果其他用户发布了满足您需求的广告，将通过 TIGA 机器人发送通知给您，并且可以一键直达交易。',
};

export const customerManagement = {
  title: '客户管理',
  whitelist: '交易白名单',
  blacklist: '交易黑名单',
  inputPlaceholder: '请输入对方的 Mixin ID',
  addToList: '输入 Mixin ID 添加',
  add: '添加',
  remove: '移除',
  addSuccessfully: '添加成功',
  removeSuccessfully: '移除成功',
};

export const communityHelper = {
  name: '社群助手',
};


export const messageHelper = {
  name: '聊天转发',
  warnInfo: '提醒：如您使用新生APP而无法使用聊天功能，可以临时使用该页面进行转发消息。建议下载Mixin Messenger以便流畅使用TIGA。',
  downloadMessenger: 'Mixin 下载页面',
  groupInfo: '当前群聊',
  textInfo: '转发文字',
  textInfoPlaceHolder: '请输入要转发的文字内容(可为空）',
  photosInfo: '转发图片',
  uploadTips: '温馨提示：本次仅为临时转发信息到群，TIGA对转发内容不作任何担保。',
  submitErr:'文字和照片不能同时都为空。',
  photosLimit: '本次最多上传3张照片',
  sendAgainInfo: '本次转发',
  sendAgainButton: '再次发送',
};

export const rebate = {
  name: '超级返佣',
  groupRatio: '你的群组返佣比例',
  inviteRatio: '你的邀请返佣比例',
  friendsRatio: '你的好友返佣比例',
  inviteNow: '立即邀请',
  total: '数据总览',
  recommend: '推荐链接',
  inviteList: '好友列表',
  rebateList: '返佣历史',

  time: ['全部时间', '今日', '昨日', '本周', '本月'],
  estimated: '预估收入',
  orderNum: '交易订单',
  customers: '交易用户',
  ranking: '总佣金收入排名：',
  viewRank: '查看排名列表',

  inviterRatio: '您的返佣比例',
  inviteeRatio: '好友返现比例',
  inviteCode: '邀请码',
  inviteLink: '邀请链接',
  inviteNum: '邀请人数',
  edit: '编辑',
  invite: '邀请',

  nickname: '昵称',
  traded: '是否交易',
  yes: '是',
  no: '否',
  inviteDate: '邀请时间',

  orderInfo: '订单号/订单类型',
  income: '佣金收入',
  orderDate: '返佣时间',
  inviteTitle: '邀请好友，一起赚钱',

  rank: '排名',
  rankList: '排名列表',
  rankBrief: '列表展示过去 24 小时排名数据，且仅展示前 20 名',
  revenue: '佣金总收入',
  noRecords: '没有找到相关记录…',
  rebateType: ['群组返佣', '公开返佣', '邀请返佣', '邀请返佣'],
};

export const statistics = {
  name: '统计',
  total: '总交易额',
  buyTotal: '总买入',
  sellTotal: '总卖出',
  buy: '买入',
  sell: '卖出',
  volume: '交易额',
  price: '均价',
  setTime: '设置时间',
  startAt: '起始时间',
  endAt: '结束时间',
  pickStartTime: '请选择起始时间',
  pickEndTime: '请选择结束时间',
  onlyMaker: '只统计发布广告的成交',
};

export const invite = {
  name: '邀请码绑定',
  placeholder: '输入邀请码',
  brief: '绑定成功之后，不支持修改',
  bind: '绑定',
  bindSuccess: '绑定成功',
  ruleTitle: '返佣规则',
  rules: [
    {
      title:
        '返佣分为<span class="strong">「群组返佣」</span>和<span class="strong">「邀请返佣」</span>',
      content:
        '「群组返佣」、「邀请返佣」适用于任何用户；',
    },
    {
      title: '<span class="strong">「群组返佣」</span>的规则也非常简单',
      content:
        '只需要将 TIGA 机器人拉入到 Mixin 群组，群成员通过群组的 TIGA 机器人下单，群主即可收到返佣；',
    },
    {
      title:
        '<span class="strong">「邀请返佣」</span>需要邀请人和被邀请人绑定邀请关系',
      content: '邀请人才会收到被邀请人交易订单的佣金；',
    },
    {
      title: '返佣<span class="strong">实时结算</span>',
      content: '结算的币种为订单交易的币种；',
    },
    {
      title: '初始返佣比例为 <span class="strong">10%</span>',
      content:
        '目前 KOL 返佣计划上线已上线，如有意愿可以<a href="https://mixin.one/codes/255b9c54-b64e-4095-a789-b66506604461">点击此处申请；</a>',
    },
  ],
  refers: [
    '<span class="strong">「社群返佣」</span>的教程参考此处',
    '<span class="strong">「全民返佣」</span>的教程参考此处',
    '<span class="strong">「邀请返佣」</span>的教程参考此处',
  ],
};

export const related = {
  name: 'TA 发布的广告',
  empty: '暂无广告在线!',
  view: '查看 TA 的广告',
};
